import React, { Component } from "react";
import * as PIXI from "pixi.js";
import UIManager from "../../core/components/ui/UiBuilder";
import { withPixiApp } from "@inlet/react-pixi";
import { GJIStore } from "../../gamestore/IStore";
import { connect } from "react-redux";
import { Dispatch } from "redux";
import withgameGuideComponentPortraitConfiguration from "./configuration/withgameGuideComponentPortraitConfiguration";
import { actions as layoutsActions } from "../../core/reducers/layoutsStateReducer";
import { isMobile } from "react-device-detect";
import { configGame, constant } from "../../data/config";
import { CURRENCY, TIMER } from "../../core/utills";



interface IStore {
    [x: string]: any;
}
interface IProps {
    [x: string]: any;
}

interface IState {

}

interface IStateToProps {
}

interface IDispatchToProps {
}

class GameGuideComponentPortrait extends Component<IProps, IState> {
    protected app: PIXI.Application;
    protected displayUI: any;
    protected gameGuideComponentPortrait: any;
    protected gameGuideComponentContainerPortrait: any;
    protected scope: any;
    protected ui_mode: string;
    protected gameGuideComponentList: Array<any>

    constructor(props: IProps) {
        super(props);
        this.app = props.app;
        this.gameGuideComponentPortrait = React.createRef();
        this.gameGuideComponentContainerPortrait = React.createRef();
        this.state = {
            uiElements: [],
            lang: "en"
        }

        if (isMobile) {
            this.ui_mode = "mobile"
        } else {
            this.ui_mode = "desktop"
        }
     
        this.gameGuideComponentList = []
        this.displayUI = this.props.data.COMPONENTS[0].child.filter(this.checkUiMode.bind(this));
    }

    checkUiMode(uimodeobj: any) {
        if (uimodeobj.uimode === undefined) {
            uimodeobj.uimode = "both"
        }
        if (uimodeobj.uimode === "both" || uimodeobj.uimode === this.ui_mode) {
            return uimodeobj;
        }
    }
    doChangesOnTranslation() {
        let RulesDescription1: any = UIManager.getRef("Rules_Description1").text;
        RulesDescription1 = RulesDescription1.replace("%v", this.props.showRTP + "%");
        UIManager.getRef("Rules_Description1") && UIManager.setText("Rules_Description1", RulesDescription1);

        let RulesDescription2: any = UIManager.getRef("Rules_Description2").text;
        RulesDescription2 = RulesDescription2.replace("%minbet", this.correctCurrencyCodeXAF(CURRENCY.CurrencyManager.formatCurrencyString(this.props.betList[0], true, true, true, true)));
        RulesDescription2 = RulesDescription2.replace("%maxbet",this.correctCurrencyCodeXAF(CURRENCY.CurrencyManager.formatCurrencyString(this.props.betList[this.props.betList.length - 1], true, true, true, true)));
        UIManager.getRef("Rules_Description2") && UIManager.setText("Rules_Description2", RulesDescription2);
    }
    correctCurrencyCodeXAF(amount: string) {
        if ((window as any).GAME_INFO.currency == "XAF") {
            return amount.replace('F', 'FCFA');
        }
        if ((window as any).GAME_INFO.currency == "XOF") {
            return amount.replace('F', 'XOF');
        }
        return amount;
    }
    bindUI() {
        if ((window as any).GAME_INFO.jurisdiction == "uk" || (window as any).GAME_INFO.jurisdiction == "nl" || (window as any).GAME_INFO.jurisdiction == "de") {
            UIManager.getRef("Control_Autoplay_Container").visible = false;
            UIManager.getRef("Control_Buy_Feature_Portrait").visible = false;
        }
        if (!this.props.disableBuyIn) {
            UIManager.getRef("Control_Buy_Feature_Portrait").visible = true;
        } else {
            UIManager.getRef("Control_Buy_Feature_Portrait").visible = false;
        }
        this.addScrollBar();
        let buyfreespinContainer2: any = UIManager.getRef("buyfreespinContainer2");
        let buyInDisplay = false;
        for (let key in this.props.langObj) {
            if (key == "tag-help-rules_Buy Free Spins") {
                buyInDisplay = true;
                break;
            }
        }
        if (!this.props.disableBuyIn) {
            buyfreespinContainer2.visible = true;
        } else {
            buyfreespinContainer2.visible = false;
        }

        if ((window as any).GAME_INFO.lang == 'zs' || (window as any).GAME_INFO.lang == 'jp') {
            UIManager.getRef("Rules_Description2").visible = false;
            UIManager.getRef("Rules_Description2_zs").visible = true;

            UIManager.getRef("WinWays_Description1").visible = false;
            UIManager.getRef("WinWays_Description1_zs").visible = true;

            UIManager.getRef("WinWays_Description2").visible = false;
            UIManager.getRef("WinWays_Description2_zs").visible = true;

            UIManager.getRef("WinWays_Description3").visible = false;
            UIManager.getRef("WinWays_Description3_zs").visible = true;

            UIManager.getRef("WinWays_Description4").visible = false;
            UIManager.getRef("WinWays_Description4_zs").visible = true;

            UIManager.getRef("tumbles_Heading1").visible = false;
            UIManager.getRef("tumbles_Heading1_zs").visible = true;

            UIManager.getRef("tumbles_Heading3").visible = false;
            UIManager.getRef("tumbles_Heading3_zs").visible = true;

            UIManager.getRef("scatter_Description1").visible = false;
            UIManager.getRef("scatter_Description1_zs").visible = true;

            UIManager.getRef("scatter_Description2").visible = false;
            UIManager.getRef("scatter_Description2_zs").visible = true;

            UIManager.getRef("additional_Description6").visible = false;
            UIManager.getRef("additional_Description6_zs").visible = true;

            UIManager.getRef("buyfreespin_Description1").visible = false;
            UIManager.getRef("buyfreespin_Description1_zs").visible = true;

            UIManager.getRef("buyfreespin_Description2").visible = false;
            UIManager.getRef("buyfreespin_Description2_zs").visible = true;

            UIManager.getRef("buyfreespin_Description3").visible = false;
            UIManager.getRef("buyfreespin_Description3_zs").visible = true;

            UIManager.getRef("buyfreespin_Description4").visible = false;
            UIManager.getRef("buyfreespin_Description4_zs").visible = true;

            UIManager.getRef("randomwild_Description1").visible = false;
            UIManager.getRef("randomwild_Description1_zs").visible = true;

            UIManager.getRef("buyfreespin_Description5").visible = false;
            UIManager.getRef("buyfreespin_Description5_jp").visible = true;

        }else {
            UIManager.getRef("Rules_Description2").visible = true;
            UIManager.getRef("Rules_Description2_zs").visible = false;

            UIManager.getRef("WinWays_Description1").visible = true;
            UIManager.getRef("WinWays_Description1_zs").visible = false;

            UIManager.getRef("WinWays_Description2").visible = true;
            UIManager.getRef("WinWays_Description2_zs").visible = false;

            UIManager.getRef("WinWays_Description3").visible = true;
            UIManager.getRef("WinWays_Description3_zs").visible = false;

            UIManager.getRef("WinWays_Description4").visible = true;
            UIManager.getRef("WinWays_Description4_zs").visible = false;

            UIManager.getRef("tumbles_Heading1").visible = true;
            UIManager.getRef("tumbles_Heading1_zs").visible = false;

            UIManager.getRef("tumbles_Heading3").visible = true;
            UIManager.getRef("tumbles_Heading3_zs").visible = false;

            UIManager.getRef("scatter_Description1").visible = true;
            UIManager.getRef("scatter_Description1_zs").visible = false;

            UIManager.getRef("scatter_Description2").visible = true;
            UIManager.getRef("scatter_Description2_zs").visible = false;

            UIManager.getRef("additional_Description6").visible = true;
            UIManager.getRef("additional_Description6_zs").visible = false;

            UIManager.getRef("buyfreespin_Description1").visible = true;
            UIManager.getRef("buyfreespin_Description1_zs").visible = false;

            UIManager.getRef("buyfreespin_Description2").visible = true;
            UIManager.getRef("buyfreespin_Description2_zs").visible = false;

            UIManager.getRef("buyfreespin_Description3").visible = true;
            UIManager.getRef("buyfreespin_Description3_zs").visible = false;

            UIManager.getRef("buyfreespin_Description4").visible = true;
            UIManager.getRef("buyfreespin_Description4_zs").visible = false;

            UIManager.getRef("randomwild_Description1").visible = true;
            UIManager.getRef("randomwild_Description1_zs").visible = false;

            UIManager.getRef("buyfreespin_Description5").visible = true;
            UIManager.getRef("buyfreespin_Description5_jp").visible = false;


        }
        if ((window as any).GAME_INFO.lang == 'jp') {
            UIManager.getRef("Rules_Description3").visible = false;
            UIManager.getRef("Rules_Description3_jp").visible = true;

            UIManager.getRef("horizontalReels_Description1").visible = false;
            UIManager.getRef("horizontalReels_Description1_jp").visible = true;

            UIManager.getRef("horizontalReels_Description2").visible = false;
            UIManager.getRef("horizontalReels_Description2_jp").visible = true;

            UIManager.getRef("lockedReel_Description1").visible = false;
            UIManager.getRef("lockedReel_Description1_jp").visible = true;

            UIManager.getRef("lockedReel_Description2").visible = false;
            UIManager.getRef("lockedReel_Description2_jp").visible = true;

            UIManager.getRef("lockedReel_Description3").visible = false;
            UIManager.getRef("lockedReel_Description3_jp").visible = true;

            UIManager.getRef("fgmultiplier_Description1").visible = false;
            UIManager.getRef("fgmultiplier_Description1_jp").visible = true;

            UIManager.getRef("fgmultiplier_Description2").visible = false;
            UIManager.getRef("fgmultiplier_Description2_jp").visible = true;

            UIManager.getRef("additional_Description2").visible = false;
            UIManager.getRef("additional_Description2_jp").visible = true;

            UIManager.getRef("additional_Description4").visible = false;
            UIManager.getRef("additional_Description4_jp").visible = true;

            UIManager.getRef("additional_Description5").visible = false;
            UIManager.getRef("additional_Description5_jp").visible = true;

        }else{
            UIManager.getRef("Rules_Description3").visible = true;
            UIManager.getRef("Rules_Description3_jp").visible = false;

            UIManager.getRef("horizontalReels_Description1").visible = true;
            UIManager.getRef("horizontalReels_Description1_jp").visible = false;

            UIManager.getRef("horizontalReels_Description2").visible = true;
            UIManager.getRef("horizontalReels_Description2_jp").visible = false;

            UIManager.getRef("lockedReel_Description1").visible = true;
            UIManager.getRef("lockedReel_Description1_jp").visible = false;

            UIManager.getRef("lockedReel_Description2").visible = true;
            UIManager.getRef("lockedReel_Description2_jp").visible = false;

            UIManager.getRef("lockedReel_Description3").visible = true;
            UIManager.getRef("lockedReel_Description3_jp").visible = false;

            UIManager.getRef("fgmultiplier_Description1").visible = true;
            UIManager.getRef("fgmultiplier_Description1_jp").visible = false;

            UIManager.getRef("fgmultiplier_Description2").visible = true;
            UIManager.getRef("fgmultiplier_Description2_jp").visible = false;

            UIManager.getRef("additional_Description2").visible = true;
            UIManager.getRef("additional_Description2_jp").visible = false;

            UIManager.getRef("additional_Description4").visible = true;
            UIManager.getRef("additional_Description4_jp").visible = false;

            UIManager.getRef("additional_Description5").visible = true;
            UIManager.getRef("additional_Description5_jp").visible = false;
        }
    }

    addScrollBar() {
        let gameGuideContent: any = UIManager.getRef("gameGuideContentPortrait")
        let gameScrollComponent: any = UIManager.getRef("gameScrollComponentPortrait")
        let rulesHeading: any = UIManager.getRef("Rules_Heading")
        const Scrollbox = require('pixi-scrollbox').Scrollbox
        const scrollbox = new Scrollbox({ boxWidth: 1080, boxHeight: 1400 })

        scrollbox.x = 0;
        scrollbox.y = 300;
        gameScrollComponent && gameScrollComponent.addChild(scrollbox)

        // add a sprite to the scrollbox's content
        const sprite = scrollbox.content.addChild(new PIXI.Sprite(PIXI.Texture.WHITE))
        sprite.width = 800
        sprite.height = 1500
        isMobile && (sprite.alpha = 0.01);
        sprite.tint = 0x131313

        scrollbox.dragScroll = true;
        scrollbox.overflowX = "none";
        // force an update of the scrollbox's calculations after updating the children

        scrollbox.content.addChild(gameGuideContent);
        // add the viewport to the stage
        scrollbox.update()
        //UIManager.getRef("nakliScroll") && (UIManager.getRef("nakliScroll").x = 145);
    }


    //when layout changes, this method will be called
    layoutChange(currentLayout: string) {
        this.doChangesOnTranslation();
        this.displayUI.map((data: any) => {
            if (data.layout === true) {
                //this.props.setApplicationLayoutObject(data.name);
            }
        }
        )
    }

    componentDidMount() {
        this.bindUI();
        this.doChangesOnTranslation();
        //this.layoutChange(this.props.layoutMode);
    }
    shouldComponentUpdate(nextProps: Readonly<IProps>, nextState: Readonly<IState>, nextContext: any): boolean {
        return true;
    }
    render() {

        return (<UIManager id={"gameGuideComponentPortrait"} name={"gameGuideComponentPortrait"} type={"Container"}
            ref={i => this.gameGuideComponentPortrait = i}
            x={0} y={0}>
            {
                this.displayUI && this.displayUI.map((i: any) =>
                    <UIManager key={`UIManager-${Math.random()}`} langObj={this.props.langObj} type={i.type}
                        id={i.id} {...i} app={this.app} />)
            }
        </UIManager>)
    }
}


export default withPixiApp(connect(
    (state: Pick<IStore, 'applicationState' | 'behaviourState'|'basegameState'>): IStateToProps =>
    ({
        //layoutMode: state.applicationState.layoutMode,
        showRTP: state.applicationState.showRTP,
        disableBuyIn: state.behaviourState.disableBuyIn,
        betList: state.basegameState.betList,
    }),
    (dispatch: Dispatch): IDispatchToProps => ({
        setApplicationLayoutObject: (layoutobjectlist: any): any => dispatch(layoutsActions.setApplicationLayoutObject(layoutobjectlist)),
    }))(withgameGuideComponentPortraitConfiguration(GameGuideComponentPortrait)));